<template>
  <v-dialog
    :model-value="modelValue"
    max-width="600px"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <v-card>
      <v-card-title class="d-flex justify-space-between"
        ><span>Validate Schema</span><v-icon>mdi-google</v-icon>
      </v-card-title>
      <v-card-text>
        <v-text-field
          :model-value="content"
          readonly
          variant="outlined"
          rows="1"
          class="mb-4"
          v-show="false"
        ></v-text-field>

        <div class="mb-4 ml-4">
          <ol>
            <li @click="copyToClipboard" class="cursor-pointer mb-4">
              <v-icon start>{{
                copied ? 'mdi-check' : 'mdi-content-copy'
              }}</v-icon>
              {{ copied ? 'Copied' : 'Click here to copy' }} placement URL
            </li>
            <li @click="copied = false" class="mb-4">
              <a
                href="https://search.google.com/test/rich-results"
                target="_blank"
                class="text-primary"
                :style="{ textDecoration: 'none' }"
                ><v-icon start>mdi-check-decagram</v-icon>Open
                <strong>Google's Rich Results Tool</strong> and paste copied
                URL</a
              >
            </li>
          </ol>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="grey"
          variant="text"
          @click="$emit('update:modelValue', false)"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { ref } from 'vue'

const props = defineProps<{
  modelValue: boolean
  content: string
}>()

const emit = defineEmits<{
  'update:modelValue': [value: boolean]
}>()

const showDialog = ref(props.modelValue)
const copied = ref(false)

const copyToClipboard = async () => {
  if (copied.value) return

  try {
    await navigator.clipboard.writeText(props.content)
    copied.value = true
    setTimeout(() => {
      copied.value = false
    }, 2000)
  } catch (err) {
    console.error('Failed to copy:', err)
  }
}
</script>
